<style lang="scss" scoped>
  .wrap-join{
    .position{
      border:1px solid #E4E6EA;
      padding:10px 20px;
      .title{
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #E4E6EA;
      }
      li{
        margin-top: 10px;
        cursor: pointer;
        &:hover, &.active{
          color:#014492;
        }
      }
    }
    .table-con{
      border:1px solid #E4E6EA;
      border-bottom: 0;
      a{
        color: #333;
      }
    }
  }
  .job-name{
    &:hover{
      color:#014492 !important;
    }
  }
  @media screen and (max-width: 640px){
    .container1{
      width: 100% !important;
      text-align: center;
    }
    section{
      margin-bottom: 20px;
    }
    .container{
      width: 100% !important;
    }
    .banner .info h2{
      font-size: 14px;
    }
    .banner .info h1{
      font-size: 16px;
    }
    [class*="el-col-"]{
      float: none!important;
    }
    .el-col-4{
      padding-left: 0px!important;
      padding-right: 0px!important;
      width: 90% !important;
      margin-left: auto;
      margin-right: auto;
    }
    .wrap-join .position{
      overflow: auto;
      margin-bottom: 20px;
    }
    .wrap-join .position ul{
      overflow: auto;
    }
    .wrap-join .position li {
      float: left;
      margin-right: 11px;
    }
    .el-col-20{
      padding-left: 0px!important;
      padding-right: 0px!important;
      width: 90% !important;
      margin-left: auto;
      margin-right: auto;
    }
    .wrap-join .position li:last-child{
      margin-right: 0;
    }
    .el-row{
      margin-left: 0px!important;
      margin-right: 0px!important;
    }
    section{
      padding-top: 20px!important;
    }
  }
  @media screen and (max-width: 641px){
    .wrap-join .breads{
      display: none!important;
    }
  }
</style>
<template>
  <div class="wrap wrap-join">
    <div class="banner">
      <img src="@/assets/img/join_us.png" class="img-fluid">
<!--      <div class="info">-->
<!--        <div class="container container1">-->
<!--          <h1>加入擎科</h1>-->
<!--          <h2 class="mt10">“专注，坚持”是我们永久不变的经营信念。<br>-->
<!--            欢迎你的加入，和擎科一起成就梦想！</h2>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="container">
        <el-row :gutter="40">
          <el-col :span="4">
            <div class="position">
              <div class="title">工作地点</div>
              <ul>
                <li :class="{active: currentTab === index}" v-for="(item, index) in position" :key="index" @click="changeTab(item.id, index)">{{item.name}}</li>
              </ul>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="table-con">
              <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                  label="职位名称">
                  <template slot-scope="scope">
                    <router-link :to="`/recruit?id=${scope.row.job.id}&locationId=${scope.row.location.id}`" class="job-name">{{scope.row.job.name}}</router-link>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="工作地点">
                  <template slot-scope="scope">{{scope.row.location.name}}</template>
                </el-table-column>
                <el-table-column
                  label="发布时间">
                  <template slot-scope="scope">{{scope.row.createTime}}</template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page" v-show="total > 10">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="changePage">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import { recruitLocations, recruitJobs } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      position: [],
      total: 0,
      page: 0,
      pageSize: 10,
      tableData: [],
      locationId: '',
      currentTab: 0
    }
  },
  created() {
    this.getLocation()
    this.getLists()
  },
  methods: {
    // 获取招聘地点
    getLocation () {
      recruitLocations().then(res => {
        res.data.unshift({name: '全部', id: ''})
        this.position = res.data
      })
    },
    changeTab (id, index) {
      this.currentTab = index
      this.getLists(id)
    },
    // 招聘列表
    getLists (id) {
      const { page, pageSize } = this
      recruitJobs(id, page, pageSize).then(res => {
        res.data.map(item => {
          item.createTime = item.createTime.replace(/T/g, ' ').replace(/Z/g, '')
        })
        this.tableData = res.data
        this.total = this.baseMethods.getTotal(res)
        this.locationId = id
      })
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getLists(this.locationId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/summary/join_us.vue